export enum DipRegistrationLoggingNames {
    OVERVIEW = 'seamless-enrollment-checklist-page',
    CUSTOMER_IDENTIFICATION = 'seamless-enrollment-customer-info-page',
    EXISTING_ACCOUNT = 'seamless-enrollment-account-already-exits',
    PHONE_NUMBER_LIST = 'seamless-enrollment-confirm-your-number',
    ACCOUNT_NUMBER_POPUP = 'seamless-enrollment-pop-up-primary-policy-holder',
    PHONE_NUMBER_POPUP = 'DipRegistrationPhoneNumberModalComponent', // no omniture tag available - using class name
    SESSION_EXPIRED = 'seamless-enrollment-session-expired',
    APPLICATION_ERROR = 'seamless-enrollment-internal-server-error',
    TECHNICAL_ERROR = 'seamless-enrollment-technical-server-error',
    FUNCTIONAL_ERROR = 'seamless-enrollment-functional-server-error',
    PAGE_NOT_FOUND = 'seamless-enrollment-404'
}
